import { render, staticRenderFns } from "./TrangTaoHoSoCanBo.vue?vue&type=template&id=701c455a&"
import script from "./TrangTaoHoSoCanBo.vue?vue&type=script&lang=js&"
export * from "./TrangTaoHoSoCanBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports